import template from './leave_taken_report_full.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveTakenFullViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.include_resigned = ko.observable(false);

		let first_day = moment().format('YYYY-MM-01');
		let last_day = moment().format('YYYY-MM-') + moment().daysInMonth();

		this.leave_taken_full = ko.observableArray('');
		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();

		this.range_start = ko.observable(new Date(first_day).toJSON().slice(0, 10));
		this.range_end = ko.observable(new Date(last_day).toJSON().slice(0, 10));
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);

		this.selected_company.subscribe((newValue) => {
			this.leave_taken_full([]);
			this.show_hint(true);
			this.show_no_data_message(false);

			if (newValue != null)
				this.current_company_id(newValue.company_id);
			else
				this.current_company_id(null);
		});

		this.selected_department.subscribe((newValue) => {
			this.leave_taken_full([]);
			this.show_hint(true);
			this.show_no_data_message(false);

			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.range_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, 'YYYY-MM-DD', true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.range_end(month_end);

			}, 500); // Wait 100ms after last interaction
		});

		this.range_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout)
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, 'YYYY-MM-DD', true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.range_start(), 'YYYY-MM-DD', true);

					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
				}
			}, 1000);
		});

		this.include_resigned.subscribe((newText) => {
			this.page.updateData();
		});
	}

	update_click()
	{
		this.show_hint(false);
		this.show_no_data_message(false);
		this.page.updateReportData();
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveTakenBreakdownByLeaveEntryHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	async download_clicked(v, e)
	{
		// Check if there's any data to download
		if (this.leave_taken_full().length === 0) {
			await Grape.alerts.alert({title: 'Warning', type: 'warning', message: 'No data to download'});
			return;
		}

		// Build CSV from the actual data array
		let csv_rows = [];

		// Add header row
		let headers = [
			'First Name',
			'Surname',
			'Employee code',
			'Start date',
			'End date',
			'Leave type',
			'Rate',
			'Days',
			'Department',
			'Company'
		];

		csv_rows.push(headers.map(h => `"${h}"`).join(','));

		// Add data rows from the observable array
		this.leave_taken_full().forEach(record => {
			let row = [
				record.firstname || '',
				record.surname || '',
				record.employee_code || '',
				record.range_start || '',
				record.range_end || '',
				record.description || '',
				record.taken_rate || '',
				record.total_days || '',
				record.department || '',
				record.company || ''
			];

			// Properly escape quotes and wrap in quotes
			csv_rows.push(row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','));
		});

		let csv_string = csv_rows.join('\n');

		// Create and download the file
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'leave_taken_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

class ReportTakenLeaveFullPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveTakenFullViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('LeaveTakenBreakdownReport'))
			return;

		document.title = tr('Leave Taken Breakdown By Leave Entry');
		window.current_page_title(tr('Leave Taken Breakdown By Leave Entry'));
	}

	updateData()
	{
		// must satisfy all 3 conditions
	}

	async updateReportData()
	{
		let data = {
			company_id: this.viewModel.current_company_id(),
			department_id: this.viewModel.current_department_id(),
			date_start: this.viewModel.range_start(),
			date_end: this.viewModel.range_end(),
			include_resigned: this.viewModel.include_resigned()
		};

		this.viewModel.leave_taken_full('');
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/reports/leave_taken_full', data);

		if (res)
		{
			if (res.leave_per_employee != null)
			{
				this.viewModel.leave_taken_full(res.leave_per_employee);
				this.viewModel.show_hint(false);
			}
			else
			{
				this.viewModel.leave_taken_full([]);
				this.viewModel.show_no_data_message(true);
			}
			this.viewModel.loader(false);
		}
	}
}

export default {
	route: '[/]report/leave_taken_full',
	page_class: ReportTakenLeaveFullPage,
	template: template,
	template_filename: 'translation/leave_taken_report_full'
};
